// extracted by mini-css-extract-plugin
export default {"headerTab":"ThemesLayout_headerTab__jT24k","headerTab__button":"ThemesLayout_headerTab__button__a3o0p","headerTab__button_active":"ThemesLayout_headerTab__button_active__TUjom"};